import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Drawer from '@material-ui/core/Drawer'
import Menu from '@material-ui/icons/Menu'
import styles from 'assets/jss/material-kit-react/components/headerStyle.js'
import HeaderLinks from './HeaderLinks'
import { useDispatch, useSelector } from 'react-redux'
import { Cancel, Refresh, Search } from '@material-ui/icons'
import { useState } from 'react'
import Searcher from 'components/harmonize/Searcher'
import { reset } from 'util/playlistUtils'
import { setShowSearch } from 'redux/actions/displayActions'

const useStyles = makeStyles(styles)

export default function SwipeCardHeader({ menuOpened, setCollectionPlaylist }) {
  const classes = useStyles()
  const semiTransparent = 'rgba(0, 0, 0, 0.25)'
  const { currentCollection, collections, playListIndex } = useSelector(state => state.harmonize)
  const { currentRoom, currentRoomOwner, playList } = useSelector(state => state.messages)
  const { showSearch } = useSelector(state => state.display)
  const HEADER_HEIGHT = currentRoom ? '4em' : '2em'
  const [showPlaylists, setShowPlaylists] = useState(false)
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const appBarClasses = classNames({
    [classes.appBar]: true
  })
  const dispatch = useDispatch()

  const getSong = () => {
    if (playList.length) {
      return playList[playListIndex]
    } else {
      return { name: '' }
    }
  }
  const handleDrawerToggle = (evt) => {
    console.log(`handleDrawerToggle drawerOpen ${drawerOpen}`)
    evt.stopPropagation()
    menuOpened(!drawerOpen)
    setDrawerOpen(!drawerOpen)
  }

  /**
   * This calls way back into Studio where the SwipeCard was instantiated that 
   * ultimately led to this component.
   * @param {*} col 
   * @param {*} ix 
   * @returns 
   */
  const displayCollectionName = (col, ix) => {
    return (
      <div key={ix} onClick={(evt) => {
        evt.stopPropagation()
        setShowPlaylists(false)
        setCollectionPlaylist(col)
      }}>
        {col.name}
      </div>
    )
  }
  const displayCollections = () => {
    if (showPlaylists) {
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '0.5em', backgroundColor: 'white',
          paddingLeft: '0.25em', paddingRight: '0.25em',
          position: 'absolute',
          width: '50vw',
          zIndex: 6000,
          top: '1.5em',
          left: 20
        }}>
          <div style={{ marginTop: HEADER_HEIGHT }}>
            {collections.map((col, ix) => displayCollectionName(col, ix))}
          </div>
        </div>)
    }
  }
  const displaySongName = () => {
    const { name } = getSong()
    return (
      <div style={{
        flex: '0.9',
        textAlign: 'center',
        fontSize: '1em',
        lineHeight: 'normal',
        fontWeight: 'bold',
        fontVariant: 'small-caps',
        color: 'white',
        WebkitTextStroke: '1px gold',
        letterSpacing: '0.2em'
      }}>
        {name}
      </div>
    )
  }

  const displayStudioName = () => {
    if (currentRoom && currentRoomOwner) {
      const { name } = currentRoom
      const roomName = name !== 'home' ? `/${name}` : null
      const { handle, firstName, lastName } = currentRoomOwner
      return (<div style={{ display: 'flex', width: '100%', color: 'white', justifyContent: 'center' }}>
        {firstName} {lastName} @{handle}{roomName}
      </div>)
    }
  }
  const displayPlayListName = () => {

    if (currentCollection && currentCollection.name.toLowerCase() !== 'studio') {

      return (<div style={{ display: 'flex', width: '100%', color: 'white', justifyContent: 'center' }}>
        {currentCollection.name}
      </div>)
    }
  }

  const displayRefresh = () => {
    if (!currentRoom) {
      return (
        <Refresh onClick={(evt) => {
          evt.stopPropagation()
          reset(dispatch)
        }}
          style={{
            fontSize: '2em', color: 'gold', padding: 0
          }} />
      )
    }

  }
  /** Search is currently only supported on the Home screen, i.e.
   * when the user is not in a specific Studio.
   */
  const displaySearch = () => {
    if (!currentRoom) {
      return (

        <Search onClick={(evt) => {
          evt.stopPropagation()
          dispatch(setShowSearch(!showSearch))
        }}
          style={{
            fontSize: '2em', color: 'gold', padding: 0
          }} />
      )
    }
  }

  const displaySearcher = () => {
    if (showSearch) {
      return (
        <div style={{
          display: 'flex',
          flex: 1,
          position: 'absolute',
          top: '3vh',
          left: '5vw',
          width: '85vw',
          alignItems: 'center',
          fontSize: '0.75em',
          backgroundColor: 'white',
          borderRadius: '1em',
          paddingLeft: '5vw', paddingRight: '0.25em'
        }}>

          <Searcher />
          <Cancel onClick={(evt) => {
            evt.stopPropagation()
            dispatch(setShowSearch(false))
          }} style={{ fontSize: '2em' }} />
        </div>)
    } else {
      return null
    }
  }

  return (
    <AppBar className={appBarClasses} style={{
      backgroundColor: semiTransparent, padding: 0,
      height: HEADER_HEIGHT,
      position: 'fixed',
      top: 0,
      visibility: drawerOpen ? 'hidden' : 'visible'
    }}>
      <Toolbar className={classes.container} >
        {/* IF you take out the next empty div the alignment is effed */}
        <div style={{
          visibility: drawerOpen ? 'hidden' : 'visible',
          display: 'flex', alignItems: 'center',
          position: 'relative', width: '100%',
          justifyContent: 'center',
          zIndex: 10000
        }}>
          {displaySearch()}
          {/*displayPlaylistHeader()*/}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {displaySongName()}
            {displayStudioName()}
            {displayPlayListName()}
          </div>
          {displayRefresh()}
          {displayCollections()}
          {displaySearcher()}

        </div>


        <Menu onClick={(evt) => handleDrawerToggle(evt)}
          style={{
            fontSize: '2em', color: 'gold', padding: 0
          }} />



      </Toolbar>

      <Drawer
        variant='temporary'
        anchor={'right'}
        open={drawerOpen}
        classes={{
          paper: classes.drawerPaper,
        }}
        onClose={(evt) => handleDrawerToggle(evt)}
      >
        <div className={classes.appResponsive} >
          <HeaderLinks />
        </div>
      </Drawer>

    </AppBar>
  )

}
